'use strict';
/* global jQuery Vue Inputmask */
/* eslint consistent-this: ["error", "self"] */

import Vue from "./../lib/vue.min";
import "inputmask";


(function($){

    var form;
    var re_email = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var popup;


    function hide_popup_node(node) {
        $(node).animate({opacity: 0}, 250, function () {
            node.style.display = 'none';
        });
    }


    function PopupBox(back, front) {
        var self = this;
        self.show = function () {
            back.style.display = 'block';
            back.style.opacity = '0';

            front.style.display = 'block';
            front.style.opacity = '0';

            $(front).animate({opacity: 1}, 250);
            $(back).animate({opacity: 0.7}, 250);

            self.center();
            // front.style.top = window.pageYOffset + 20 + 'px';
        };

        self.hide = function () {
            hide_popup_node(back);
            hide_popup_node(front);
        };

        self.center = function () {
            front.style.top = window.pageYOffset + 20 + 'px';
        };
    }


    function set_error(node) {
        node.closest('.form-group, .chek-wrap').classList.add('error');
    }


    function hide_error(node) {
        node.closest('.form-group').classList.remove('error');
    }

    function getToken() {
        return $('meta[name="csrf-token"]').attr('content')
    }


    function init_faq_form () {
        form = new Vue({
            el: '#popup_faq_form',
            template: '#question_form_template',
            data: function () {
                return {
                    username: '',
                    tel: '',
                    email: '',
                    message: '',
                    card_number: '',
                    agree: false,
                    valid: true,
                    disabled: false,
                    error: false,
                    error_code: '',
                    error_text: '',
                    done: false,
                };
            },
            mounted: function () {
                var self = this;

                var input = self.$el.querySelector('#faq_tel');
                Inputmask({
                    placeholder: '',
                    showMaskOnHover: false,
                    oncomplete: function () {
                        self.tel = this.value;
                    }
                }).mask(input);

                input = self.$el.querySelector('#faq_card_number');
                Inputmask({
                    placeholder: '',
                    showMaskOnHover: false,
                    oncomplete: function () {
                        self.card_number = this.value;
                    },
                }).mask(input);

            },
            methods: {

                submit: function () {
                    var self = this;
                    self.disabled = true;

                    $.post('/add_question', {
                            username: self.username,
                            tel: self.tel,
                            email: self.email,
                            message: self.message,
                            card_number: self.card_number,
                            '_token': getToken(),
                        })
                        .done(function (data) {
                            if (data.status_text == 'ok') {
                                self.done = true;
                            }
                        })
                        .fail(function (data, textStatus, errorThrown) {
                            self.error = true;
                            self.error_code = data.status;
                            self.error_text = data.statusText;
                        })
                        .always(function () {
                            self.disabled = false;
                        });
                },

                check_form: function () {
                    var self = this;
                    self.valid = true;
                    self.error = false;

                    // if (self.card_number === '' && !/[0-9]{13}/.test(self.card_number)) {
                    //     self.valid = false;
                    //     set_error(self.$el.querySelector('#faq_card_number'));
                    // }

                    if (self.username === '') {
                        console.log('username error --- ', );
                        self.valid = false;
                        set_error(self.$el.querySelector('#faq_username'));
                    }

                    if (self.tel === '') {
                        self.valid = false;
                        set_error(self.$el.querySelector('#faq_tel'));
                    }

                    if (!re_email.test(self.email)) {
                        self.valid = false;
                        set_error(self.$el.querySelector('#faq_email'));
                    }

                    if (self.message === '') {
                        self.valid = false;
                        set_error(self.$el.querySelector('#faq_message'));
                    }

                    if (!self.agree) {
                        self.valid = false;
                        set_error(self.$el.querySelector('#agree-mes'));
                    }

                    if (self.valid) {
                        self.submit();
                    }

                },

                hide_error: function (event) {
                    hide_error(event.target);
                },

                hide_faq_form: function () {
                    popup.hide();
                },
            }

        });
    }


    function show_faq_form (event) {
        event.preventDefault();
        popup.show();
    }


    document.addEventListener('DOMContentLoaded', function(){
        var link_form = document.querySelector('.help-link_form');

        if(document.getElementById('popup_faq_form')) {
            init_faq_form();
            popup = new PopupBox(
                document.getElementById('shadow_box'),
                document.getElementById('popup_faq_form')
            );
        }

        if(link_form) {
            link_form.addEventListener('click', show_faq_form);
        }


    });

}(jQuery));
